<model-page [model]="model" [form]="mainForm">
  <navigation-bar [model]="model" [current-index]="2"></navigation-bar>
  <form name="mainForm" #mainForm="ngForm" class="form-horizontal">
    <fieldset *ngIf="style=='default'">
      <legend>Er wordt zo spoedig mogelijk contact met u opgenomen.</legend>
      <div class="form-group row">
        <div class="col-sm-12">
          <p>Uw gegevens zijn ontvangen.</p>
        </div>
      </div>
    </fieldset>
    <fieldset *ngIf="style=='zzp'">
      <legend class="align-center">
        <img class="bevestiging-mail-sent" alt="Email sent" />
        <div>Bedankt voor het aanvragen van een premie-indicatie voor een arbeidsongeschiktheidsverzekering.</div>
      </legend>
      <div class="form-group row align-center">
        <div class="col-sm-12">
          <p>Je e-mail is succesvol verzonden, de premie-indicatie volgt per e-mail.</p>
        </div>
      </div>
    </fieldset>
    <div class="row">
      <div class="offset-md-6 col-sm-6 text-right">
        <button type="button" class="btn btn-primary" (click)="onBack()">Ga terug naar Vergelijker</button>
      </div>
    </div>
  </form>
</model-page>
